/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.patients

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf
import studio.oddpods.cauce.core.base.ui.EventsEffect
import studio.oddpods.cauce.core.ui.scaffold.KptScaffold
import studio.oddpods.cauce.feature.patients.generated.resources.Res
import studio.oddpods.cauce.feature.patients.generated.resources.patients_edit_title

@Composable
fun PatientEditScreen(
    patientId: String,
    onBackClick: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: PatientEditViewModel = koinViewModel { parametersOf(patientId) },
) {
    val state by viewModel.stateFlow.collectAsStateWithLifecycle()

    EventsEffect(eventFlow = viewModel.eventFlow) { event ->
        when (event) {
            PatientEditEvent.SaveSuccess -> onBackClick()
        }
    }

    KptScaffold(
        onNavigationIconClick = onBackClick,
        title = stringResource(Res.string.patients_edit_title),
        modifier = modifier,
    ) {
        if (state.isLoading) {
            Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                CircularProgressIndicator()
            }
        } else {
            PatientFormContent(
                state = state,
                onAction = { action ->
                    when (action) {
                        is PatientFormAction.NameChanged -> viewModel.trySendAction(
                            PatientEditAction.NameChanged(action.name),
                        )

                        is PatientFormAction.PhoneChanged -> viewModel.trySendAction(
                            PatientEditAction.PhoneChanged(action.phone),
                        )

                        is PatientFormAction.EmailChanged -> viewModel.trySendAction(
                            PatientEditAction.EmailChanged(action.email),
                        )

                        is PatientFormAction.FeeChanged -> viewModel.trySendAction(
                            PatientEditAction.FeeChanged(
                                action.fee,
                            ),
                        )

                        is PatientFormAction.NotesChanged -> viewModel.trySendAction(
                            PatientEditAction.NotesChanged(action.notes),
                        )

                        PatientFormAction.SaveClicked -> viewModel.trySendAction(
                            PatientEditAction.SaveClicked,
                        )
                    }
                },
                modifier = Modifier
                    .fillMaxSize()
                    .padding(horizontal = 16.dp),
            )
        }
    }
}
